import ME from './me.gql';
import SAVE_ME from './saveMe.gql';

export { ME, SAVE_ME };
